import { Grid, Box } from '@mui/material';

import Form from 'components/Form';
import { IFormRegister, IFormValues } from 'routes/Main/type';

import SectionTitle from '../../components/SectionTitle';

interface Props extends IFormRegister, IFormValues {
  disabled?: boolean;
}

const checks = [
  {
    label: '請始終將床上的護欄升起。',
    key: 'fall_education.checked1',
  },
  {
    label: '將患者的必需品放在附近，以免因伸手拿物品而跌倒。',
    key: 'fall_education.checked2',
  },
  {
    label: '清理床周圍的區域，避免因水、線纜、儀器等物品導致跌倒事故。',
    key: 'fall_education.checked3',
  },
  {
    label: '大部分時間由監護人陪伴患者。',
    key: 'fall_education.checked4',
  },
  {
    label: '監護人需要幫助患者夜間醒來時使用衛生間或去其他地方。',
    key: 'fall_education.checked5',
  },
  {
    label: '如果感到頭暈，請不要立即從床上起身。',
    key: 'fall_education.checked6',
  },
  {
    label: '如果需要幫助，請使用呼叫器尋求幫助。',
    key: 'fall_education.checked7',
  },
  {
    label: '走向輪椅時，請特別注意地板高度的差異。',
    key: 'fall_education.checked8',
  },
];

const EducationList = (props: Props) => {
  const { disabled, register, getValues, setValue } = props;

  return (
    <>
      <SectionTitle title="跌倒預防教育" />
      <Box sx={{ width: '98%', margin: '48px auto 24px auto' }}>
        <Grid container xs={12}>
          {checks.map((v, i) => (
            <Grid item xs={12}>
              <Form.MuiCheckbox
                label={v.label}
                disabled={disabled}
                defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                onChange={(_, checked) => {
                  setValue(v.key, checked);
                }}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
};

export default EducationList;
